module.exports = "images/favicon-16x16.7d58be728a44ef62eef46666c58f65a8.png";